<template>
  <Table
    :rows="payload"
    :columns="columns"
    :busy="busy"
    :row-style-class="rowStyleClass"
    @on-row-click="(e) => $emit('on-row-click', e)"
  />
</template>

<script type="text/javascript">
import Table from '@/components/Table.vue';
import PartnerLogo from '@/components/Partners/PartnerLogo.vue';
import StatusBadge from '@/components/StatusBadge.vue';

export default {
  name: 'PartnersTable',
  components: { Table },
  props: {
    payload: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    rowStyleClass: {
      type: Function,
      required: false,
      default: () => 'cursor-pointer hover:bg-hint',
    },
    busy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    columns() {
      return [
        {
          label: 'Id',
          field: 'id',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>{row.id}</b>,
          sortable: false,
        },
        {
          label: 'Имя',
          field: 'name',
          tdClass: 'align-middle',
          cell: ({ row }) => <div class="flex flex-row items-center space-x-4">
            <PartnerLogo partner={row} />
            <b>{row.name}</b>
          </div>,
          sortable: false,
        },
        {
          label: 'ИНН',
          field: 'inn',
          tdClass: 'align-middle',
          cell: ({ row }) => <span>{row.inn}</span>,
          sortable: false,
        },
        {
          label: 'Сайт',
          field: 'site',
          tdClass: 'align-middle',
          cell: ({ row }) => <span>{row.site}</span>,
          sortable: false,
        },
        {
          label: 'Email',
          field: 'email',
          tdClass: 'align-middle',
          cell: ({ row }) => <span>{row.email}</span>,
          sortable: false,
        },
        {
          label: '% партнера',
          field: 'percent',
          tdClass: 'align-middle',
          cell: ({ row }) => <span>{row.percent}</span>,
          sortable: false,
        },
        {
          label: 'UUID',
          field: 'uuid',
          tdClass: 'align-middle',
          cell: ({ row }) => <span>{row.uuid}</span>,
          sortable: false,
        },
        {
          label: ' ',
          field: 'enable',
          tdClass: 'align-middle',
          cell: ({ row }) => <div class="flex justify-end">
            {(() => {
              if (row.enable) {
                return <StatusBadge status="active" />;
              }
              return null;
            })()}
          </div>,
          sortable: false,
        },
      ];
    },
  },
};
</script>
